module.exports = __webpack_public_path__ + "static/img/why-4.2d8e9b3f.jpg";